/* eslint-disable import-extensions/file-extension-required */
import { useEffect } from 'react';

import { fg } from '@confluence/feature-gating';

import { useSetBulkIssuesList } from '../providers/BulkCreateContextProvider.tsx';
import { useIssueCreateSidePanelContext } from '../providers/IssueCreateSidePanelContextProvider.tsx';
import { useAiBulkNavigationGotoPage } from '../providers/AiBulkNavigationContextProvider.tsx';
import { useMappingsState } from '../providers/BulkConfigureContextProvider';

import { mapActionItemsToIssues } from './actionItemUtils.tsx';

export const useMapActionItemsToIssues = (): void => {
	const [{ selectedActionItems }] = useIssueCreateSidePanelContext();
	const setBulkIssuesList = useSetBulkIssuesList();
	const goToPage = useAiBulkNavigationGotoPage();
	const { optionsIssueTypeFields, loadingIssueTypeFields } = useMappingsState();

	useEffect(() => {
		if (!selectedActionItems) {
			return;
		}

		if (!fg('confluence-create-work-items-from-action-items')) {
			return;
		}

		// When fast follows is enabled, require Jira metadata to be fully loaded
		if (fg('confluence-ai-jira-work-create-fast-follows')) {
			if (
				!optionsIssueTypeFields ||
				optionsIssueTypeFields.length === 0 ||
				loadingIssueTypeFields
			) {
				return;
			}
		}

		const mappedIssues = mapActionItemsToIssues(selectedActionItems);
		void setBulkIssuesList(mappedIssues);
		if (mappedIssues.length === 0) {
			void goToPage('configure');
		}
	}, [
		goToPage,
		setBulkIssuesList,
		selectedActionItems,
		optionsIssueTypeFields,
		loadingIssueTypeFields,
	]);
};
